import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminPackages({ adminKey }) {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(null);
  const headers = { "X-Admin-Key": adminKey };

  useEffect(() => {
    axios.get(`${API}/admin/packages`, { headers }).then((r) => setItems(r.data.packages)).catch(() => toast.error("تعذّر تحميل الباقات"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminKey]);

  const toggle = async (p, enabled) => {
    setBusy(p.id);
    try {
      const { data } = await axios.post(`${API}/admin/packages/${p.id}`, { enabled }, { headers });
      setItems((list) => list.map((x) => ({ ...x, enabled: data.enabled.includes(x.id) })));
      toast.success(enabled ? `تم تفعيل «${p.name_ar}»` : `تم إيقاف «${p.name_ar}»`);
    } catch {
      toast.error("تعذّر حفظ التغيير");
    } finally {
      setBusy(null);
    }
  };

  const activeCount = items?.filter((p) => p.enabled).length ?? 0;

  return (
    <section data-testid="admin-packages-section" dir="rtl" className="rounded-2xl border border-[#2e3a5c] bg-[#1b2540] p-4 sm:p-5 font-arabic text-white">
      <div className="flex items-center justify-between gap-2 mb-3">
        <h2 className="text-base font-black">باقات الشراء</h2>
        <span data-testid="admin-packages-active-count" className="text-[11px] text-white/60">المفعّل الآن: {activeCount}</span>
      </div>
      <p className="text-[11px] text-white/55 mb-3">الباقات الموقوفة تختفي من نافذة الشراء ويرفض الخادم الدفع عليها. الأرصدة والاشتراكات المشتراة سابقًا لا تتأثر.</p>
      {!items ? (
        <div className="text-[12px] text-white/50">جارٍ التحميل...</div>
      ) : (
        <ul className="divide-y divide-white/5">
          {items.map((p) => (
            <li key={p.id} data-testid={`admin-package-row-${p.id}`} className="flex items-center justify-between gap-3 py-2.5">
              <div className="min-w-0">
                <div className="text-[13px] font-bold">{p.name_ar}</div>
                <div className="text-[11px] text-white/55">
                  <span className="font-mono-num">{p.amount}</span> ر.س · {p.type === "subscription" ? `اشتراك ${p.days} يومًا` : `${p.credits} اقتراح`}
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className={`text-[11px] font-bold ${p.enabled ? "text-[#18c98f]" : "text-white/40"}`}>{p.enabled ? "مفعّلة" : "موقوفة"}</span>
                <div dir="ltr" className="flex">
                  <Switch
                  data-testid={`admin-package-toggle-${p.id}`}
                  checked={p.enabled}
                  disabled={busy === p.id || (p.enabled && activeCount === 1)}
                  onCheckedChange={(v) => toggle(p, v)}
                />
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
